import React, { useState } from "react";
// import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import SubmitButtons from "../DialogBoxComponent/SubmitButtons";
import CancelButtons from "../DialogBoxComponent/CancelButtons";
import { Divider } from "@mui/material";
import { makeStyles } from "@material-ui/core";
import { Dialog } from "@material-ui/core";
import { ReactComponent as CloseSvg } from "../../../src/assets/Close.svg";
import CloseIcon from "@mui/icons-material/Close";

import { DialogActions } from "@mui/material";
import FilterForm from "./FilterForm";

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    borderRadius: "20px",
    // minWidth:'1500px'
  },
}));

export default function CustomerDialog(props) {
  const classes = useStyles();

  const { onSubmit, children, onClose, ...other } = props;

  const handleClose = () => {
    props.onClose(false);
  };
  return (
    <>
      <Dialog
        classes={{ paper: classes.dialogPaper }}
        {...props}
        disableBackdropClick
        disableEscapeKeyDown
        BackdropProps={{
          style: {
            backdropFilter: "blur(5px)",
          },
        }}
      >
        <DialogTitle variant="h4">
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 15,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
          {props.Header}
        </DialogTitle>
        <Divider />
        <div
          style={{
            maxHeight: "60vh",
            overflowY: "auto",

            paddingBottom: "8px",
            paddingTop: "16px",
            paddingRight: "24px",
            paddingLeft: "24px",
          }}
        >
          {props.children}
        </div>
        <DialogActions
          style={{
            justifyContent: "center",
            display: "flex",
            flexDirection: "row",
            // marginBottom: "20px",
            // marginTop: "25px",
          }}
        >
          <CancelButtons onClick={() => props.cancel()}>
            <Typography variant="body1" style={{ textTransform: "none" }}>
              {props.cancelText}
            </Typography>
          </CancelButtons>

          <SubmitButtons onClick={onSubmit} type="submit">
            <Typography variant="body1" style={{ textTransform: "none" }}>
              {props.acceptText}
            </Typography>
          </SubmitButtons>
        </DialogActions>
      </Dialog>
    </>
  );
}
